import React, { useEffect, useState, useMemo, memo } from "react"
import Select from "react-select"

const CustomSelect = ({
  options,
  onChange,
  name,
  defaultValue,
  value,
  isDisabled,
  isLoading,
  isClearable,
}) => {
  return (
    <React.Fragment>
      <Select
        name={name}
        options={options}
        defaultValue={defaultValue}
        value={value}
        className="basic-single"
        classNamePrefix="select"
        onChange={onChange}
        isDisabled={isDisabled}
        isLoading={isLoading && isLoading}
        isClearable={isClearable}
      />
    </React.Fragment>
  )
}

export default CustomSelect
